import React from 'react';

import PropTypes from 'prop-types';

import {
  StylableComponent,
  stylePropType,
  variantSwitch,
} from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';

import { ThemeVariant, VARIANTS } from '../consts';

type BodyProps = StylableComponent<HTMLDivElement> & {
  variant?: ThemeVariant;
  padding?: string | number;
  maxWidth?: string | number;
};

const Body = React.forwardRef<HTMLDivElement, BodyProps>(
  (
    {
      className,
      style,
      children,
      variant = VARIANTS.DARK,
      padding = '8px 12px',
      maxWidth = '300px',
      ...props
    },
    ref
  ) => (
    <div
      className={className}
      ref={ref}
      css={[
        theme.typography.bodySmall,
        { padding, maxWidth, overflowWrap: 'break-word' },
        variantSwitch({
          statement: variant,
          variants: {
            [VARIANTS.LIGHT]: {
              color: theme.colors.charcoal900,
              backgroundColor: theme.colors.white,
              borderRadius: 4,
              boxShadow: theme.shadows.highElevation,
            },
            [VARIANTS.DARK]: {
              color: theme.colors.white,
              backgroundColor: theme.colors.charcoal900,
              borderRadius: 2,
            },
          },
        }),
        style,
      ]}
      {...props}
    >
      {children}
    </div>
  )
);

Body.displayName = 'Body';

Body.propTypes = {
  /** className */
  className: PropTypes.string,
  /** style */
  style: stylePropType,
  /** children */
  children: PropTypes.node,
  /** variants */
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  /** padding */
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** maxWidth */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Object.assign(Body, { VARIANTS });
